import React from 'react';
import { Box, Button, FormControl, InputLabel, OutlinedInput, Typography } from '@mui/material';
import InfoIcon from 'app/components/Icons/InfoIcon';
import {
  btn,
  infoDataText,
  infoText,
  input,
  inputDiv,
  inputDivDisabled,
  inputsBlock,
  styles,
  textDesc,
  userInfoBlock,
  userInfoText,
} from './MainPage.sx';
import useMainPage from 'app/components/MainPage/useMainPage';
import Select, { components } from 'react-select';

const CustomValueContainer = ({ children, ...props }: any) => {
  return (
    <components.ValueContainer {...props}>
      <components.Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </components.Placeholder>
      {children.map((child: any) => (child && child.key !== 'placeholder' ? child : null))}
    </components.ValueContainer>
  );
};

const MainPage = () => {
  const {
    fin,
    handleOnChangeFin,
    handleOnChangeCustomerId,
    customerId,
    handleOnClick,
    dataGetUserData,
    selectedCreditType,
    creditTypeOptions,
    handleChangeCreditType,
    accNumber,
    endDate,
    mainCredit,
    creditAmount,
    perAmount,
    paidAmount,
    handleOnChangeCardBin,
    handleOnChangeAmount,
    handleOnClickSendData,
    cardBin,
    amount,
    isLoadingGetUserData,
    isLoadingSendData,
  } = useMainPage();

  return (
    <Box sx={userInfoBlock}>
      <Typography sx={textDesc}>Müştəri məlumatlarını daxil edin</Typography>
      <form>
        <Box sx={inputsBlock}>
          <Box sx={inputDiv}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel htmlFor="fin">FİN / VÖEN</InputLabel>
              <OutlinedInput id="fin" sx={input} onChange={(e: any) => handleOnChangeFin(e)} label="FİN" />
            </FormControl>
          </Box>
          <Box sx={inputDiv}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel htmlFor="customer-id">Müştəri ID</InputLabel>
              <OutlinedInput id="customer-id" sx={input} onChange={(e: any) => handleOnChangeCustomerId(e)} />
            </FormControl>
          </Box>
        </Box>

        {(dataGetUserData === undefined || dataGetUserData?.result === 'error') && (
          <Button
            sx={btn}
            disabled={fin.length === 0 || customerId.length === 0 || isLoadingGetUserData}
            onClick={handleOnClick}
          >
            Davam et
          </Button>
        )}
        {dataGetUserData?.result === 'error' && (
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              p: '13px 24px',
              border: '1px solid #EA0029',
              mt: '24px',
              borderRadius: '8px',
              backgroundColor: 'rgba(234, 0, 41, 0.1)',
            }}
          >
            <InfoIcon sx={{ fill: '#EA0029' }} color="error" />
            <Typography>{dataGetUserData?.error.text}</Typography>
          </Box>
        )}
        {dataGetUserData !== undefined && dataGetUserData?.result === 'accepted' && (
          <Box>
            <Typography sx={userInfoText}>Müştəri məlumatları</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <Box sx={inputsBlock}>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="customer_name">Müştəri A.S.A</InputLabel>
                    <OutlinedInput
                      id="customer_name"
                      sx={input}
                      label="Müştəri A.S.A"
                      disabled
                      value={dataGetUserData?.customer_name}
                    />
                  </FormControl>
                </Box>
                <Box sx={dataGetUserData?.loans.length === 1 ? inputDivDisabled : inputDiv}>
                  <FormControl sx={{ width: '100%' }}>
                    <Select
                      components={{ IndicatorSeparator: () => null, ValueContainer: CustomValueContainer }}
                      styles={styles}
                      isDisabled={dataGetUserData?.loans.length === 1}
                      options={creditTypeOptions}
                      value={selectedCreditType}
                      onChange={handleChangeCreditType}
                      placeholder={'Kredit növü'}
                      isMulti={false}
                      isClearable={false}
                      isSearchable={false}
                      hideSelectedOptions={false}
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={inputsBlock}>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="acc_type">Hesab nömrəsi</InputLabel>
                    <OutlinedInput id="acc_type" sx={input} label="Hesab nömrəsi" disabled value={accNumber} />
                  </FormControl>
                </Box>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="end_date">Verilmə tarixi</InputLabel>
                    <OutlinedInput id="end_date" sx={input} label="Verilmə tarixi" disabled value={endDate} />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={inputsBlock}>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="credit_balance">Kredit məbləği</InputLabel>
                    <OutlinedInput
                      id="credit_balance"
                      sx={input}
                      label="Kredit məbləği"
                      disabled
                      value={creditAmount}
                    />
                  </FormControl>
                </Box>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="credit_amount">Əsas borc</InputLabel>
                    <OutlinedInput id="credit_amount" sx={input} label="Əsas borc" disabled value={mainCredit} />
                  </FormControl>
                </Box>
              </Box>
              <Box sx={inputsBlock}>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="per_credit">Faiz borcu</InputLabel>
                    <OutlinedInput id="per_credit" sx={input} disabled label="Faiz borcu" value={perAmount} />
                  </FormControl>
                </Box>
                <Box sx={inputDivDisabled}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="paid_amount">Ödəniləcək məbləğ</InputLabel>
                    <OutlinedInput id="paid_amount" sx={input} disabled label="Ödəniləcək məbləğ" value={paidAmount} />
                  </FormControl>
                </Box>
              </Box>
            </Box>
            {!dataGetUserData?.data_visible && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: '32px', gap: '8px' }}>
                <InfoIcon />
                <Typography sx={infoDataText}>
                  Məlumatların əks olunması üçün Yelo mobil tətbiqdə Ayarlar bölməsində "Terminallarda balansı
                  göstərmək" funksiyasını aktiv etmək lazımdır.
                </Typography>
              </Box>
            )}
            <Typography sx={userInfoText}>Ödəniş məlumatları</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
              <Typography sx={{ fontSize: '12px', color: '#939393' }}>
                Ödəniş edəcəyiniz kartın ilk 6 rəqəmini daxil edin
              </Typography>
              <Box sx={inputDiv}>
                <FormControl sx={{ width: '100%' }}>
                  <InputLabel htmlFor="card_number">Kartın ilk 6 rəqəmi</InputLabel>
                  <OutlinedInput
                    id="card_number"
                    sx={input}
                    label="Kartın ilk 6 rəqəmi"
                    onChange={(e: any) => handleOnChangeCardBin(e)}
                    inputProps={{ maxLength: 6 }}
                  />
                </FormControl>
              </Box>
              <Box>
                <Box sx={inputDiv}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="amount">Məbləğ</InputLabel>
                    <OutlinedInput
                      id="amount"
                      sx={input}
                      label="Məbləğ"
                      onChange={(e: any) => handleOnChangeAmount(e)}
                    />
                  </FormControl>
                </Box>
                <Typography sx={{ fontSize: '14px', color: '#CCC', mt: '8px' }}>Min.: 0.01 AZN</Typography>
              </Box>
            </Box>

            {/* {dataGetUserData.calculate_fee && (
              <>
                <Box sx={{ ...inputDiv, mt: 1 }}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel htmlFor="comission">Ödəniləcək məbləğ üçün komissiya</InputLabel>
                    <OutlinedInput id="amount" sx={input} value={amount && commissionPercentage ? commissionPercentage : ''} disabled />
                  </FormControl>
                </Box>
                 <Typography sx={{ fontSize: '14px', color: '#CCC', mt: '8px' }}>Komissiya: 0.5% ( Min: 0.01 AZN )</Typography>

                <Box sx={{ ...inputDiv, mt: 1 }}>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel shrink htmlFor="commission_amount">
                      Yekun mebleg
                    </InputLabel>
                    <OutlinedInput
                      autoFocus
                      id="commission_amount"
                      sx={input}
                      value={commissionAmount ?? ''}
                      disabled
                    />
                  </FormControl>
                </Box>
              </>
            )} */}

            <Button
              sx={btn}
              onClick={handleOnClickSendData}
              disabled={cardBin.length === 0 || amount.length === 0 || selectedCreditType === null || isLoadingSendData}
            >
              Davam et
            </Button>
          </Box>
        )}

        <Typography sx={infoText}>
          Qeyd edilən xanalara tələb olunan məlumatları daxil etməklə kreditinizi daha sürətli şəkildə ödəyə bilərsiniz.
        </Typography>
      </form>
    </Box>
  );
};

export default MainPage;
